<template>
    <section>
<!-- Services Section
==========================================-->

<div id="services" class="text-center page">
      <div class="container page">
        <div class="section-title center">
            <h2 class="text-center"><strong>our services</strong></h2>
            <div class="line">
            </div>
            <div class="clearfix"></div>
            <p class="text-center">
              <em>Free yourself from the complexity and cost of Technology. Let us handle IT for you.</em><br>
              <em>from conception to completion together let's get it done</em>
  </p>
        </div>

        <div class="space"></div>
      
        <div class="row">
            <CloudComputing/>
            <DigitalTransformation/>
        </div>

        <div class="row">
            <InfrastructureManagement/>
            <SecurityMaintenance/>
        </div>       
      
        <div class="row">
          <AppDevlopment/>
          <WebDevelopment/>
        </div>
        <div class="row">
          <TalentManagement/>
        </div>
    </div>
</div>

</section>
</template>

<script>
import InfrastructureManagement from "./InfraStructureManagement"
import CloudComputing from "./CloudComputing"
import AppDevlopment from "./AppDevlopment"
import WebDevelopment from "./WebDevelopment"
import SecurityMaintenance from "./SecurityMaintenance"
import TalentManagement from "./TalentManagement"
import DigitalTransformation from "./DigitalTransformation"
  
export default {
    components:{AppDevlopment,CloudComputing,DigitalTransformation,InfrastructureManagement,WebDevelopment,SecurityMaintenance,TalentManagement},
}
</script>


